import {
    GET_FAVORITOS_REF,
    GET_FAVORITOS_REF_SUCCESS,
    GET_FAVORITOS_REF_ERROR,
    ADD_FAVORITES_REF,
    ADD_FAVORITES_REF_SUCESS,
    ADD_FAVORITES_REF_ERROR,
    EDIT_FAVORITES_REF_ERROR,
    DELETE_FAVORITES_REF,
    DELETE_FAVORITES_REF_SUCESS,
    DELETE_FAVORITES_REF_ERROR,
    GET_MESSAGES_FAVORITES_SERVICES,
    GET_MESSAGES_FAVORITES_SERVICES_SUCCESS,
    GET_MESSAGES_FAVORITES_SERVICES_ERROR,
    GET_TOOLTIP_FAVORITE,
    CREATE_TOOLTIP_FAVORITE,
    CREATE_TOOLTIP_FAVORITE_SUCCESS,
    CREATE_TOOLTIP_FAVORITE_ERROR,
    GET_TOOLTIP_FAVORITE_SUCCESS,
    GET_TOOLTIP_FAVORITE_ERROR
  } from "../actions/favoritosRef";
  
  const initialState = {
    isLoading: false,
    ResponseSuccess: {},
    ResponseError: undefined,
    tooltiipSucces:{},
    tooltiipError:undefined,
    CodeError: 'CP0529',
    favoriteServicesMessages: [],
    isLoadingMessages: false,
  };
  
  export default (
    state = initialState,
    {
      type,
      ResponseSuccess,
      ResponseError,
      tooltiipSucces,
      tooltiipError,
      CodeError,
      errorMessagesFavoritesServices,
      favoriteServicesMessages,
    }
  ) => {
    switch (type) {
      case GET_FAVORITOS_REF:
        
        return {
          ...state,
          isLoading: true,
        };
      case GET_FAVORITOS_REF_SUCCESS:
        return {
          ...state,
          ResponseSuccess,
          isLoading: false,
          ResponseError: undefined,
        };
      case GET_FAVORITOS_REF_ERROR:
        return {
          ...state,
          ResponseError,
          isLoading: false,
          CodeError:'CP0530',
          ResponseSuccess: {},
        };
      case ADD_FAVORITES_REF:
        return {
          ...state,
          isLoading: true,
        };
      
      case ADD_FAVORITES_REF_SUCESS:
        return {
          ...state,
          ResponseSuccess,
          isLoading: false,
          ResponseError: undefined,
        };
      
      case ADD_FAVORITES_REF_ERROR:
        return {
          ...state,
          ResponseError,
          isLoading: false,
          CodeError: 'CP0529',
          ResponseSuccess: {},
        };
      case EDIT_FAVORITES_REF_ERROR:
        return {
          ...state,
          ResponseError,
          isLoading: false,
          CodeError: 'CP0521',
          ResponseSuccess: {},
        };
      case DELETE_FAVORITES_REF:
        return {
          ...state,
          isLoading: true,
        };
      case DELETE_FAVORITES_REF_SUCESS:
        return {
          ...state,
          ResponseSuccess,
          isLoading: false,
          ResponseError: undefined,
        };
      case DELETE_FAVORITES_REF_ERROR:
        return {
          ...state,
          ResponseError,
          isLoading: false,
          CodeError: 'CP0525',
          ResponseSuccess: {},
        };
        case CREATE_TOOLTIP_FAVORITE:
        return {
          ...state,
          isLoading: true,
        };
      case CREATE_TOOLTIP_FAVORITE_SUCCESS:
        return {
          ...state,
          tooltiipSucces,
          isLoading: false,
          tooltiipError: undefined,
        };
      case CREATE_TOOLTIP_FAVORITE_ERROR:
        return {
          ...state,
          tooltiipError,
          isLoading: false,
          tooltiipSucces: {},
        };
        case GET_TOOLTIP_FAVORITE:
          return {
            ...state,
            isLoading: true,
          };
        case GET_TOOLTIP_FAVORITE_SUCCESS:
          return {
            ...state,
            tooltiipSucces,
            isLoading: false,
            tooltiipError: undefined,
          };
        case GET_TOOLTIP_FAVORITE_ERROR:
          return {
            ...state,
            tooltiipError,
            isLoading: false,
            tooltiipSucces: {},
          };
      case GET_MESSAGES_FAVORITES_SERVICES:
        console.log("GET_MESSAGES_FAVORITES_SERVICES");
        return {
          ...state,
          isLoadingMessages: false,
        };
      case GET_MESSAGES_FAVORITES_SERVICES_SUCCESS:
        return {
          ...state,
          favoriteServicesMessages,
          isLoadingMessages: false
        }
      case GET_MESSAGES_FAVORITES_SERVICES_ERROR:
        return {
          ...state,
          errorMessagesFavoritesServices,
          isLoadingMessages: false,
        }
      default:
        return state;
    }
  };
  